import { useQuery } from '@tanstack/react-query';
import { fetchContacts } from '../services/contacts';

export const useContacts = (token) =>
  useQuery({
    queryKey: ['contacts'],
    enabled: !!token,
    queryFn: () => fetchContacts(token),
    staleTime: 2 * 60 * 1000,
  });
